module.exports = __webpack_public_path__ + "static/media/ic_callback_status_general.128b0e42.svg";